import get from 'lodash/get';
import { FEATURE_IDS } from 'constants/identifiers';
import { useConfigContext } from 'contexts/ConfigProvider';
import { formatPhysicianName } from 'utils/format';

const ReviewPCP = ({ state }) => {
    const { featureFlags } = useConfigContext();
    const enableLocationSelection =
        featureFlags[FEATURE_IDS.PCP_LOCATION_SELECTION];
    const physicianProps = state?.enrollment.page2.physicianInfo;
    return (
        <div className="row">
            <div className="col-md-5">
                <ul>
                    <li>
                        Medical Group:{' '}
                        <strong>
                            {physicianProps && physicianProps['ipaName']}
                        </strong>
                    </li>
                    <li>
                        ID:{' '}
                        <strong>
                            {physicianProps && physicianProps['provID']}
                        </strong>
                    </li>
                    <li>
                        PCP:{' '}
                        <strong>
                            {physicianProps &&
                                formatPhysicianName(
                                    get(physicianProps, 'nppes.firstName'),
                                    get(physicianProps, 'nppes.middleName'),
                                    get(physicianProps, 'nppes.lastName'),
                                    get(physicianProps, 'nppes.suffix')
                                )}
                        </strong>
                    </li>
                </ul>
            </div>
            <div className="col-md-5">
                <ul>
                    <li>
                        Phone Number:{' '}
                        <strong>
                            {physicianProps && physicianProps['phone']}
                        </strong>
                    </li>
                    {enableLocationSelection && (
                        <li>
                            Address:{' '}
                            <strong>
                                {physicianProps &&
                                    `${physicianProps.address1} ${physicianProps.address2} ${physicianProps.city}, ${physicianProps.state} ${physicianProps.zip}`}
                            </strong>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default ReviewPCP;
